// extracted by mini-css-extract-plugin
export default {"labell":"MyFormControl_labell__MJSCR","selecttext":"MyFormControl_selecttext__lgZ0m"};